export default __webpack_public_path__ + "static/media/Active_Setting.778e8e8a.svg";